.scolab-switcher-s3dialogselector {
    display: flex;
    gap: 8px;
    padding: 8px;
}

.scolab-switcher-s3dialogselector > * {
    flex: 1;
}

.scolab-switcher-s3dialogselector-loading {
    justify-content: center;
    min-height: 40px;
}

.scolab-switcher-s3dialogselector-loading > .scolab-switcher-loading-indicator {
    flex: none;
}

.scolab-switcher-s3dialogselector-popup {
    position: absolute;
    bottom: 120px;
    height: 300px;
    width: 500px;
    left: 50%;
    transform: translateX(-50%);
    overflow: auto;
    border-radius: 4px;
    color: #fff;
    background: #111213;
    box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
    padding: 9px;
    display: flex;
    flex-direction: column;
}

.scolab-switcher-s3dialogselector-choice {
    display: flex;
    text-align: left;
    background: transparent;
    border: 0;
    font-family: "Open Sans", arial, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 6px;
    margin-bottom: 6px;
    border-radius: 4px;
    cursor: pointer;
}


.scolab-switcher-s3dialogselector .env-switcher-label button {
    width: 223px;
}

.scolab-switcher-s3dialogselector-choice:hover {
    background: #0086EC;
}

.scolab-switcher-s3dialogselector-choice.active {
    background: #0068B8;
}

.scolab-switcher-s3dialogselector-choice strong {
    font-weight: normal;
    text-overflow: ellipsis;
    color: white;
    flex: 1;
}

.scolab-switcher-s3dialogselector-choice time {
    text-align: right;
    font-weight: 700;
    color: white;
    opacity: 0.5;
}
